import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";


const initialState = {
  verificationStatus: {
    fetching: true,
    emailVerificationStatus: {
      Email: null,
      IsVerified: false
    },
    billingInformationStatus: {
      IsCompleted: false
    },
    accountCreated: false,
    subscriptionStatus: {
      Exists: false,
      IsActive: false,
      Plan: null,
      Status: 'Unknown'
    },
    error: null,
    completed: false
  },
  verificationEmail: {
    initiated: false,
    sent: false,
    error: null
  }
}

const fetchStatus = (state, action) => {
  return updateObject(state, {
    verificationStatus: initialState.verificationStatus
  });
}

const fetchStatusOk = (state, action) => {
  return updateObject(state, {
    verificationStatus: {
      fetching: false,
      emailVerificationStatus: action.data.EmailVerificationStatus,
      accountCreated: action.data.AccountCreated,
      subscriptionStatus: action.data.SubscriptionStatus,
      error: null
    }
  });
}

const fetchStatusError = (state, action) => {
  return updateObject(state, {
    verificationStatus: {
      fetching: false,
      emailVerificationStatus: initialState.verificationStatus.emailVerificationStatus,
      error: action.error
    }
  });
}

const emailVerified = (state, action) => {
  const emailVerificationStatus = updateObject(state.verificationStatus.emailVerificationStatus, {
    IsVerified: action.isVerified
  });

  return updateObject(state, {
    verificationStatus: updateObject(state.verificationStatus, {
      emailVerificationStatus: emailVerificationStatus
    })
  });
}

const sendVerificationEmail = (state, action) => {
  return updateObject(state, {
    verificationEmail: updateObject(state.verificationEmail, {
      initiated: true
    })
  });
}

const sendVerificationEmailError = (state, action) => {
  return updateObject(state, {
    verificationEmail: updateObject(state.verificationEmail, {
      initiated: false,
      error: action.error
    })
  });
}

const setVerificationEmailSent = (state, action) => {
  return updateObject(state, {
    verificationEmail: updateObject(state.verificationEmail, {
      initiated: false,
      sent: true,
      error: null
    })
  });
}

const clearVerificationEmailSent = (state, action) => {
  return updateObject(state, {
    verificationEmail: updateObject(state.verificationEmail, {
      initiated: false,
      sent: false,
      error: null
    })
  });
}


export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.accountVerification.FETCH_STATUS:
      return fetchStatus(state, action);
    case actionTypes.accountVerification.FETCH_STATUS_OK:
      return fetchStatusOk(state, action);
    case actionTypes.accountVerification.FETCH_STATUS_ERROR:
      return fetchStatusError(state, action);
    case actionTypes.accountVerification.EMAIL_VERIFIED:
      return emailVerified(state, action);
    case actionTypes.accountVerification.SEND_VERIFICATION_EMAIL:
      return sendVerificationEmail(state, action);
    case actionTypes.accountVerification.SET_VERIFICATION_EMAIL_SENT:
      return setVerificationEmailSent(state, action);
    case actionTypes.accountVerification.CLEAR_VERIFICATION_EMAIL_SENT:
      return clearVerificationEmailSent(state, action);
    case actionTypes.accountVerification.SEND_VERIFICATION_EMAIL_ERROR:
      return sendVerificationEmailError(state,action);
    default:
      return state;
  }
}